/**
 * @description
 * Objeto PersonsByIdNumCtrlDig
 */

import { AmbitoRepresenta } from "./ambitorepresenta.model";

export class RepresentantsAOC {
    
    public identificadorlegal: string;
    public estat: string;
    public datacreacion: string;
    public datainivigencia: string;
    public datafivigencia: string;
    public poderdanttipdocident: string;
    public poderdantdocident: string;
    public poderdanttippers: string;
    public poderdantnomraosocial: string;
    public poderdantcognoms: string;
    public poderdantemail: string;
    public poderdantaccavisos: string;
    public poderdantdataaccavisos: string;
    public representanttipdocident: string;
    public representantdocident: string;
    public representanttippers: string;
    public representantnomraosocial: string;
    public representantcognoms: string;
    public representantemail: string;
    public representantaccavisos: string;
    public representantdataaccavisos: string;
    public ambitoRepresenta: AmbitoRepresenta = new AmbitoRepresenta();
    public dboid: string;
    public licencia: boolean;
  
    constructor() {}
  
}